module.exports = __webpack_public_path__ + "media/blc.1853c5bd.mp4";